import { render } from "./ModalAddEditBranch.vue?vue&type=template&id=182707b7"
import script from "./ModalAddEditBranch.vue?vue&type=script&lang=js"
export * from "./ModalAddEditBranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__